import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import Services from "../../services/services";
function BreadCrumAsync({
    sectionOneLabel,
    sectionOneUrl,
    sectionTwoLabel,
    sectionTwoUrl,
}) {
    const service = new Services();
    const feedData = useSelector((state) => state.feedData);
    let location = useLocation();
    const [MypathName, setMypathName] = useState();

    useEffect(() => {
        find_path(location.pathname);
        async function find_path(pathname) {
            if (pathname) {
                const databody = {
                    pathname: pathname,
                    _token: window.Laravel.csrfToken,
                };
                await service
                    .API(`/api/info/pathasync`, {
                        method: "POST",
                        data: { ...databody },
                    })
                    .then((data) => {
                        if (data.rc_code == "1") {
                            setMypathName(data.data);
                        }
                    });
            }
        }
        return () => { };
    }, []);


    return (
        <div
            role="section"
            className={`${location.pathname == '/list/pastCommittee' || location.pathname == '/list/about_member' ? '' : "shadow-lg bg-white"} border-2 border-gray-50 rounded-lg p-2`}
        >
            <div className="text-gray-700 text-sm lg:text-base hidden md:block font-light">
                <ul className="flex mb-0">
                    <li>
                        <a
                            href={`/home`}
                            className="hover:no-underline text-gray-700"
                            target="_self"
                        >
                            หน้าหลัก&nbsp;
                        </a>
                    </li>
                    {MypathName &&
                        MypathName[0] &&
                        MypathName.map((val, i) => {
                            return (
                                <li
                                    className={`${val.hightlight && val.hightlight
                                        ? "font-medium"
                                        : "font-light"
                                        } `}
                                    key={i}
                                >
                                    <a
                                        href={val.url && val.url}
                                        className="hover:no-underline text-gray-700"
                                        target="_self"
                                    >
                                        <label>&nbsp;/&nbsp;</label>
                                        {val.label && val.label}&nbsp;
                                    </a>
                                </li>
                            );
                        })}

                    {/* <li className={`${!sectionTwoLabel && "font-semibold"}`}>
                        <a
                            href={sectionOneUrl && sectionOneUrl}
                            className="hover:no-underline"
                            target="_self"
                        >
                            <label>&nbsp;/&nbsp;</label>
                            {sectionOneLabel && sectionOneLabel}&nbsp;
                        </a>
                    </li>
                    {sectionTwoUrl && (
                        <li className="font-semibold">
                            <a
                                href={sectionTwoUrl && sectionTwoUrl}
                                className="hover:no-underline"
                                target="_self"
                            >
                                <label>&nbsp;/&nbsp;</label>{" "}
                                {sectionTwoLabel && sectionTwoLabel}&nbsp;
                            </a>
                        </li>
                    )} */}
                </ul>
            </div>

            <div className="text-gray-700 text-sm lg:text-base block md:hidden">
                <ul className="list-disc list-inside">
                    <li>
                        <a
                            href={`/home`}
                            className="hover:no-underline"
                            target="_self"
                        >
                            หน้าหลัก
                        </a>
                    </li>
                    {MypathName &&
                        MypathName[0] &&
                        MypathName.map((val, i) => {
                            return (
                                <li
                                    className={`${val.hightlight && val.hightlight
                                        ? "font-medium"
                                        : "font-light"
                                        } `}
                                    key={i}
                                >
                                    <a
                                        href={val.url && val.url}
                                        className="hover:no-underline text-gray-700"
                                        target="_self"
                                    >
                                        <label>&nbsp;/&nbsp;</label>
                                        {val.label && val.label}&nbsp;
                                    </a>
                                </li>
                            );
                        })}
                    {/* <li>
                        <a
                            href={sectionOneUrl && sectionOneUrl}
                            className="hover:no-underline"
                            target="_self"
                        >
                            {sectionOneLabel && sectionOneLabel}
                        </a>
                    </li>
                    {sectionTwoUrl && (
                        <li>
                            <a
                                href={sectionTwoUrl && sectionTwoUrl}
                                className="hover:no-underline"
                                target="_self"
                            >
                                {sectionTwoLabel && sectionTwoLabel}
                            </a>
                        </li>
                    )} */}
                </ul>
            </div>
        </div>
    );
}

export default BreadCrumAsync;
